<template>
  <div class="mainBox">
    <div class="ruleBoxMarsk" v-if="ruleShow">
      <div class="ruleBox">
        <img @click="ruleShow = false" src="../../assets/images/cashWheel/close.png" alt="" class="closeRuleBtn">
        <div class="title">{{$t('lang.cashWheel.ruleTitle')}}</div>
        <div class="ruleContentBox" v-html="RuleText"></div>
      </div>
    </div>
    <img @click="closePage()" src="../../assets/images/cashWheel/close.png" class="closeIcon" alt="">
<!--    <div @click="closePage()" class="closeBox">-->
<!--      <img  class="back" src="../../assets/images/cashWheel/back.png" alt="">-->
<!--      <div class="backText">{{$t('lang.cashWheel.backText')}}</div>-->
<!--    </div>-->
    <img class="ruleBtnIcon" @click="ruleShow = true" src="../../assets/images/cashWheel/ruleBtnIcon.png" alt="">
    <div class="noStartMarsk" v-if="!isStart">
      <div class="freezeBox1">
        <img class="lock" src="../../assets/images/cashWheel/lock-fill.png" alt="">
        <div class="text">{{$t('lang.cashWheel.activity')}}</div>
        <div class="text">{{$t('lang.cashWheel.notStartedYet')}}</div>
      </div>
      <div class="freezeBox2">
        <img class="lock" src="../../assets/images/cashWheel/lock-fill.png" alt="">
      </div>
    </div>
    <div v-if="drawing" class="transparentMarsk"></div>
    <modalOverSuccessful v-if="modalOverSuccessfulShow" @closeModalOverSuccessful="closeModalOverSuccessful"></modalOverSuccessful>
    <modalBoxNoSpinChancesYet v-if="modalBoxNoSpinChancesYetShow" @closeNoSpinChancesYet="closeNoSpinChancesYet" @earnChanceNoSpinChancesYet="earnChanceNoSpinChancesYet()"></modalBoxNoSpinChancesYet>
    <modalBoxGetChance v-if="modalBoxGetChanceShow" @closeModalBoxGetChance="closeModalBoxGetChance" :chanceNum="chanceNum">
      <div class="rewardBox">
        <img src="../../assets/images/cashWheel/chanceIcon.png" class="chanceIcon" alt="">
        <div class="chanceNum">X{{chanceNum}}</div>
      </div>
    </modalBoxGetChance>
    <modallBoxShare v-if="modalBoxShareShow" :UsedDrawCount="UsedDrawCount" :chance="chance" @closeModalBoxShare="closeModalBoxShare" @setChanceAndBalance="setChanceAndBalance"></modallBoxShare>
    <modalTask v-if="modalTaskShow" :balance="balance" @closeModalTask="closeModalTask" @getSuccess="getSuccess"></modalTask>
    <modalGuide v-if="modalGuideShow" @closeModalGuide="closeModalGuide" @goInviteModalGuide="goInviteModalGuide"></modalGuide>
    <modalConfirmWithdraw :withDrawVal="withDrawVal" :value="withDrawValue" v-if="modalConfirmWithdrawShow" @closeModalConfirmWithdraw="closeModalConfirmWithdraw"></modalConfirmWithdraw>
    <modalEarnMoreMoney v-if="modalEarnMoreMoneyShow" @closeModalEarnMoreMoney="closeModalEarnMoreMoney"></modalEarnMoreMoney>
    <modalPleaseContinue v-if="modalPleaseContinueShow" @closeModalPleaseContinue="closeModalPleaseContinue"></modalPleaseContinue>
    <modalRegisterAccount v-if="modalRegisterAccountShow" @closeRegisterAccount="closeRegisterAccount"></modalRegisterAccount>
    <moadlTopWinner v-if="moadlTopWinnerShow" @closeMoadlTopWinner="closeMoadlTopWinner"></moadlTopWinner>
    <modalGetReceived  v-if="modalGetReceivedShow" @closeModalBoxGetReceived="closeModalBoxGetReceived">
      ₹{{ receivedValue }}
    </modalGetReceived>
    <div :class="counter===2?'sideBoder':'sideBoderHide'" :style="{'backgroundImage':'url('+require('../../assets/images/cashWheel/sideBoderBg.png')+')'}">
      <img class="userImg" :src="randomData.userImg" alt="">
      <div class="textBox">
        <div class="userName">{{randomData.userName}}</div>
        <div class="description">
          <span class="text">{{$t('lang.cashWheel.withdrew')}} </span>
          <span class="value" style="margin-left: 0.5vw">{{randomData.amount}}</span>
          <span class="text">&nbsp;{{lang==='EN' ?randomData.getTime :randomData.getTimeIN}}</span>
        </div>
<!--        <div class="reachedAccount">-->
<!--          {{randomData.amount}}-->
<!--        </div>-->
      </div>
    </div>
    <img style="position: absolute;z-index: 10;width: 100%" src="../../assets/images/cashWheel/pageBg.webp" alt="">
    <div class="headBox">
      <div class="title">
        {{$t('lang.cashWheel.wheelOfFortune')}}
      </div>
      <div class="maxWin">{{$t('lang.cashWheel.maxWin')}}</div>
      <div class="chanceBox">
        <div class="chance">
          {{$t('lang.cashWheel.chance')}}:{{ chance }}
        </div>
        <div>
          <div :class="canNums?'ruleIconBoxMove':'ruleIconBox'">
            <div class="ruleIconNums" v-if="canNums">{{canNums}}</div>
            <img src="../../assets/images/cashWheel/ruleIcon.png" class="ruleIcon" alt="" @click="openModalTask">
          </div>
        </div>
      </div>
    </div>
    <div class="lottery">
      <div class="wheelBorder" :style="{'backgroundImage':'url('+require('../../assets/images/cashWheel/wheelBgOutside.webp')+')'}">
        <img class="bonusFocusImg" v-show="!this.drawing && balance!==0" src="../../assets/images/cashWheel/bonusFocusImg.png" alt="">
        <div
          class="lottery-wheel"
          :style="{
          '-webkit-transition': wheelTransition,
          '-webkit-transform': rotateAngle,
        }"
        >
          <img style="width: 66vw;position: absolute;z-index: 10;" src="../../assets/images/cashWheel/wheelBg.webp" alt="">
          <img @click="lotterydraw" style="width: 66vw;position: absolute;z-index: 11;" src="../../assets/images/cashWheel/wheelBgBonus.png" alt="">
          <ul class="prize-list">
            <li
              class="prize-item"
              v-for="(item, index) in prizeList"
              :key="index"
            >
              <span>{{ item.prize_pic }}</span>
              <!--            <img :src="item.prize_pic" alt/>-->
            </li>
          </ul>
        </div>
        <div class="lotterydraw">
          <img
            @click="lotterydraw"
            src="../../assets/images/cashWheel/wheelItemBg.webp"
            alt=""
          />
        </div>
      </div>

    </div>
    <!-- 中奖结果 -->
  <!--    <div class="lotteryname" v-if="lotteryshow">恭喜你中奖{{ lotteryname }}</div>-->
    <div class="btnBox">
      <div class="btnItem" :style="{'backgroundImage':'url('+require('../../assets/images/cashWheel/itemBtnBg1.png')+')'}" @click="openModalBoxShare">
        <div class="label">{{$t('lang.cashWheel.Begin')}}</div>
      </div>
      <div class="btnItem1" :style="{'backgroundImage':'url('+require('../../assets/images/cashWheel/itemBtnBg2.png')+')'}" @click="lotterydraw">
        <div class="label">{{$t('lang.cashWheel.request')}}</div>
      </div>
    </div>
    <div class="myWinBox" :style="{'backgroundImage':'url('+require('../../assets/images/cashWheel/myWinBg.png')+')'}">
      <div class="row1">
        {{$t('lang.cashWheel.myWinningBalance')}}
      </div>
      <div class="row2">₹ {{balance}}</div>
      <div class="row3" v-if="balance < 500">
        <div class="leftBox">
          <div>{{$t('lang.cashWheel.WithdrawalAvailableuponReaching')}}</div>
          <div>{{$t('lang.cashWheel.WithdrawalAvailableuponReaching2')}}</div>
          </div>
        <div class="rightBox">₹500</div>
      </div>
      <div v-else class="ReceiveReward" @click="openModalConfirmWithdraw()">{{$t('lang.cashWheel.ReceiveReward')}}</div>
    </div>
    <div class="ListWinners" :style="{backgroundImage:'url('+require('../../assets/images/cashWheel/ListWinnersBg.png')+')'}">
      <div class="listViewMask"></div>
      <div class="listOfWinners">{{$t('lang.cashWheel.listOfWinners')}}</div>
      <div class="listView" ref="listView">
        <el-carousel height="30vw" ref="carousel" @mouseout="false"  @change="lookCarousel"  direction="vertical" indicator-position="none" :interval="delay" :loop="isLoop">
          <el-carousel-item v-for="(chunk, chunkIndex) in chunkedUserDataList" :key="chunkIndex">
            <div v-for="(item, index) in chunk" :key="index" class="viewItem">
              <div class="userInfoBox">
                <img class="userImg" :src="item.userImg" alt="">
                <div class="userName">{{ item.userName }}</div>
              </div>
              <div class="TimeBox">{{ lang === 'EN' ? item.getTime : item.getTimeIN }}</div>
              <div class="withDraw">{{ $t('lang.cashWheel.withdraw') }} <span>{{ item.amount }}</span></div>
            </div>
          </el-carousel-item>
        </el-carousel>
      </div>
    </div>
    <div class="inviteBox" :style="{'backgroundImage':'url('+require('../../assets/images/cashWheel/inviteBoxBg.png')+')'}" @click="goInvite()">
      <div class="labelBox">
        <div :class="lang==='IN'?'label1IN':'label1'">{{ $t('lang.cashWheel.get') }} <span class="value">₹100</span> </div>
        <div :class="lang==='IN'?'label2IN':'label2'">{{ $t('lang.cashWheel.forEveryInvite') }}</div>
      </div>
      <div :class="lang==='IN'?'inviteTipIN':'inviteTip'">{{ $t('lang.cashWheel.inviteTip') }}</div>
    </div>
  </div>
</template>

<script>
import modalBoxNoSpinChancesYet from './modalBox-NoSpinChancesYet'
import modalBoxGetChance from './modalBox-getChance'
import modallBoxShare from './modallBox-share'
import modalTask from './modal-task'
import modalGuide from './modal-guide'
import modalConfirmWithdraw from './modal-confirmWithdraw'
import modalEarnMoreMoney from './modal-earnMoreMoney'
import modalPleaseContinue from './modal-pleaseContinue'
import modalRegisterAccount from './modal-registerAccount'
import modalOverSuccessful from './modal-overSuccessful'
import moadlTopWinner from './modal-topWinner'
import modalGetReceived from './modalBox-getReceived'
import request from '@/service'
import { userDataList } from './userData'
import { Toast } from 'mint-ui'
export default {
  components: {
    modalBoxNoSpinChancesYet,
    modalBoxGetChance,
    modallBoxShare,
    modalTask,
    modalGuide,
    modalConfirmWithdraw,
    modalEarnMoreMoney,
    modalPleaseContinue,
    modalRegisterAccount,
    modalOverSuccessful,
    moadlTopWinner,
    modalGetReceived
  },
  computed: {
    withDrawVal () {
      return Math.floor(this.balance) - Math.floor(this.balance) % 500
    },
    chunkedUserDataList () {
      return this.chunkArray(this.userDataList, 3)
    }
  },
  beforeRouteLeave (to, from, next) {
    if (to.name === 'Share') {
      next('/Home')
    } else {
      next()
    }
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      vm.getStartStatus()
      vm.addEventListenerToDocument()
      if (from.name === 'Promotion') {
        vm.saveUserEvent()
      }
      if (from.name === 'Earn') {
        vm.backPath = 'back'
      }
    })
  },
  data () {
    return {
      ruleShow: false,
      backPath: null,
      isStart: true,
      isLoop: true,
      canNums: 0,
      lang: localStorage.getItem('locale'),
      WinnersList: [
        {
          userImg: '../../assets/images/cashWheel/250e12fb0b14a6d994571c183d5eff0ff0dd5bee1e22c-1ZIZu2_fw658.webp',
          userName: 'Meet death',
          getTime: '1',
          amount: '500₹'
        },
        {
          userImg: '../../assets/images/cashWheel/606a5fa499c65bcefc092a0a5e85fa01.jpg',
          userName: 'Meet death',
          getTime: '1',
          amount: '500₹'
        },
        {
          userImg: '../../assets/images/cashWheel/618cea1e16b539075.jpg',
          userName: 'Meet death',
          getTime: '1',
          amount: '500₹'
        }
      ],
      scrollDuration: 200,
      visitorCode: localStorage.getItem('visitorCode'),
      shareCloseReaminNums: 2,
      withDrawValue: 500,
      maskBoxShow: false,
      moadlTopWinnerShow: false,
      modalOverSuccessfulShow: false,
      modalRegisterAccountShow: false,
      modalPleaseContinueShow: false,
      modalEarnMoreMoneyShow: false,
      modalConfirmWithdrawShow: false,
      modalBoxNoSpinChancesYetShow: false,
      modalBoxGetChanceShow: false,
      modalBoxShareShow: false,
      modalTaskShow: false,
      modalGuideShow: false,
      modalGetReceivedShow: false,
      chanceNum: 3,
      chance: 0,
      VIRRegisterSuccess: false,
      balance: 0,
      counter: 0,
      interval: null,
      timer: null,
      timers: null,
      LuckyIndex: 0, // 回馈下标
      wheelStartRotateDegree: 0, // 转盘初始化角度
      wheelTransition: 'transform  5s ease-in-out', // 初始化转盘
      rotateAngle: 0, // 转盘要转的角度
      rotating: false, // 转盘完成在次开始判断
      prizeKey: '5',
      prizeList: [
        {
          prize_pic:
            '₹77-111',
          prize_key: '1'
        },
        {
          prize_pic:
            '₹11-77',
          prize_key: '2'
        },
        {
          prize_pic:
            '₹0.37-10',
          prize_key: '3'
        },
        {
          prize_pic:
            '₹500',
          prize_key: '4'
        },
        {
          prize_pic:
            '₹3000',
          prize_key: '5'
        },
        {
          prize_pic:
            '₹111-177',
          prize_key: '6'
        }
      ], // 转盘数据
      RuleText: '',
      userDataList: userDataList,
      intervalId: null,
      cloumnList: [],
      lotteryname: '', // 中奖奖品名称
      lotteryshow: false,
      drawing: false,
      roteNum: 0,
      UsedDrawCount: null,
      delay: null,
      receivedValue: 0,
      isOpenModalTopWinner: false,
      aginOpenModalBoxShare: false,
      randomData: {
        userImg: require('../../assets/images/cashWheel/pexels-danxavier-1212984.webp'),
        userName: 'Farewell',
        getTime: '3 minutes Ago',
        getTimeIN: '3 मिनट पहले',
        amount: '500₹'
      }
    }
  },
  watch: {
    balance (val) {
      if (val % 500 === 0) {
        this.withDrawValue = this.balance
      } else {
        this.withDrawValue = 500
      }
    },
    '$store.state.locale': function (val) {
      this.lang = val
    }
  },
  methods: {
    goInvite () {
      this.$router.push('/Earn')
    },
    getRule () {
      let data = {
        Type: 'VirMainRule',
        Local: localStorage.getItem('locale'),
        UserId: JSON.parse(localStorage.getItem('userInfo')) ? JSON.parse(localStorage.getItem('userInfo')).UserId : null
      }
      request('post', '/innovation/virality/get/rule', data, false).then(res => {
        this.RuleText = res.RuleText.replace(/\n/g, '<br>')
      })
    },
    lookCarousel (val) {
      if (val === this.userDataList.length / 3 - 1) {
        this.shuffleArray(this.userDataList)
      }
    },
    shuffleArray (array) {
      for (let i = array.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [array[i], array[j]] = [array[j], array[i]] // 交换元素
      }
    },
    shuffleUserDataList () {
      this.shuffleArray(this.userDataList)
    },
    setRandomTimer () {
      // 生成2-6秒的随机时间
      const delay = Math.floor(Math.random() * (6000 - 2000 + 1)) + 2000

      // 设置定时器
      this.timers = setTimeout(() => {
        // 可以在这里执行更多操作

        // 如果需要重复定时器，可以重新调用setRandomTimer()
        this.setRandomTimer()
        this.delay = delay
      }, delay * 2)
    },
    chunkArray (array, size) {
      const chunkedArray = []
      for (let i = 0; i < array.length; i += size) {
        chunkedArray.push(array.slice(i, i + size))
      }
      return chunkedArray
    },
    // 埋点
    saveUserEvent () { // 埋点
      const url = '/innovation/account/save/user/event'
      const data = {
        EventNameEN: 'openFromPromotion',
        UserUniqueId: JSON.parse(localStorage.getItem('userInfo')) ? JSON.parse(localStorage.getItem('userInfo')).UserId : null
      }
      request('post', url, data, true).then(res => {
      }).catch(err => {
        console.log(err)
      })
    },
    getRandomInterval (min, max) {
      this.shuffleArray(this.userDataList)
      return Math.floor(Math.random() * (max - min + 1)) + min
    },
    setuserDataList () {
      this.userDataList.forEach(item => {})
    },
    setWinValue (val) {
      if (val >= 0.37 && val <= 10) {
        this.prizeKey = '3'
      } else if (val >= 11 && val <= 77) {
        this.prizeKey = '2'
      } else if (val >= 77 && val <= 111) {
        this.prizeKey = '1'
      } else if (val >= 111 && val <= 177) {
        this.prizeKey = '6'
      } else if (val === 500) {
        this.prizeKey = '4'
      } else if (val === 3000) {
        this.prizeKey = '5'
      } else {
        this.prizeKey = '3'
      }
      this.gameRotate(this.prizeKey, this.prizeList)
    },
    getViralityInfo () {
      let data = {
        UserId: JSON.parse(localStorage.getItem('userInfo')) ? JSON.parse(localStorage.getItem('userInfo')).UserId : null,
        visitorCode: this.visitorCode
      }
      request('post', 'innovation/virality/info', data, false).then(res => {})
    },
    getStartStatus () {
      let data = {
        UserId: JSON.parse(localStorage.getItem('userInfo')) ? JSON.parse(localStorage.getItem('userInfo')).UserId : null,
        visitorCode: this.visitorCode
      }
      request('post', 'innovation/virality/status', data, false).then(res => {
        this.isStart = res
        this.getViralityEnter()
      })
    },
    getViralityEnter (noCloseBoxGetChanceShow) {
      let data = {
        UserId: JSON.parse(localStorage.getItem('userInfo')) ? JSON.parse(localStorage.getItem('userInfo')).UserId : null,
        visitorCode: this.visitorCode
      }
      request('post', 'innovation/virality/enter', data, false).then(res => {
        this.UsedDrawCount = res.Data.UsedDrawCount
        this.balance = res.Data.Balance
        if (this.isStart) {
          clearInterval(this.interval)
          this.counter = 0
          this.updateCounter()
          this.selectGet()
          this.shuffleArray(this.userDataList)
          this.setRandomTimer()
          this.startTimer()
          if (res.Data.IsFirstEnter) {
            setTimeout(() => {
              this.chanceNum = 3
              this.openModalBoxGetChance()
              setTimeout(() => {
                this.chance = res.Data.RemainingDrawCount
              }, 1000)
            }, 1000)
            // VIRRegisterSuccess
          } else {
            this.chance = res.Data.RemainingDrawCount
          }
          if (res.Data.RemainingDrawCount !== 0) {
            this.VIRRegisterSuccess = localStorage.getItem('VIRRegisterSuccess')
            if (this.VIRRegisterSuccess) {
              this.chanceNum = 1
              this.openModalBoxGetChance()
              // this.openModalPleaseContinue()
              localStorage.removeItem('VIRRegisterSuccess')
              localStorage.removeItem('shareVIRData')
            }
          }
        }
      })
    },
    withdraw () {
      let data = {
        UserId: JSON.parse(localStorage.getItem('userInfo')) ? JSON.parse(localStorage.getItem('userInfo')).UserId : null,
        amount: this.withDrawVal
      }
      request('post', 'innovation/virality/withdrawal', data, false).then(res => {
        if (res.Code === 1) {
          this.balance = res.Data.Balance
          Toast(this.$t('lang.account.copySuccess'))
          setTimeout(() => {
            this.openModalEarnMoreMoney()
          }, 1000)
        }
      })
    },
    draw () {
      this.drawing = true
      let data = {
        UserId: JSON.parse(localStorage.getItem('userInfo')) ? JSON.parse(localStorage.getItem('userInfo')).UserId : null,
        visitorCode: this.visitorCode
      }
      request('post', 'innovation/virality/draw', data, false).then(res => {
        if (res.Code === 1) {
          this.chance = res.Data.RemainingDrawCount
          this.UsedDrawCount = res.Data.UsedDrawCount
          this.receivedValue = res.Amount
          this.setWinValue(res.Amount)
          setTimeout(() => {
            this.drawing = false
            this.openModalBoxGetReceived()
          }, 6000)
          // 需要等转盘转完再增balance
          setTimeout(() => {
            this.balance = res.Data.Balance
          }, 7000)
        } else {
          Toast({ message: res.Message, duration: 5000 })
        }
      })
    },
    lotterydraw () {
      if (this.chance === 0) {
        if (localStorage.getItem('userInfo')) {
          this.openNoSpinChancesYet()
        } else {
          this.openRegisterAccount()
        }
        return
      }
      if (!this.drawing) {
        // 转盘方法
        this.draw()
      }
    },
    // 转盘逻辑
    // eslint-disable-next-line camelcase
    gameRotate (prize_key, prizeList) {
      this.rotating = true
      const len = prizeList.length
      // 这里循环判断转盘数据的prize_key和中奖的prize_key匹配
      for (let i = 0; i < len; i++) {
        // eslint-disable-next-line camelcase
        if (prizeList[i].prize_key === prize_key) {
          this.LuckyIndex = i
        }
      }
      const result = [360, 300, 240, 180, 120, 60]
      let FIXED_TIMES = 10
      const addDegree = (FIXED_TIMES + 1) * 360
      let rotateAngleNum =
        this.wheelStartRotateDegree +
        addDegree +
        result[this.LuckyIndex] -
        (this.wheelStartRotateDegree % 360)
      this.wheelStartRotateDegree = rotateAngleNum // 转盘初始化角度
      this.rotateAngle = `rotate(${rotateAngleNum}deg)` // 转盘要转的角度

      setTimeout(() => {
        this.gameover()
      }, FIXED_TIMES) // 延时，保证转盘转完
    },
    // 转盘转完可再次转
    gameover () {
      this.rotating = false
      //   中奖奖品
      // this.lotteryshow = true
      // this.gameRotate(this.prize_key, this.prizeList)
    },
    openNoSpinChancesYet () {
      this.modalBoxNoSpinChancesYetShow = true
    },
    openModalBoxGetChance (chanceNum) {
      this.modalBoxGetChanceShow = true
    },
    openModalBoxShare () {
      this.modalBoxShareShow = true
    },
    openModalTask () {
      this.modalTaskShow = true
    },
    setChanceAndBalance (data) {
      let datas = JSON.parse(data)
      console.log(datas)
      if (datas.RemainingDrawCount !== 0) {
        this.chanceNum = 1
        this.closeModalBoxShare(true)
        setTimeout(() => {
          this.openModalBoxGetChance()
        }, 1000)
        setTimeout(() => {
          this.chance = datas.RemainingDrawCount
        }, 1000)
      }
    },
    openModalGuide () {
      this.modalGuideShow = true
    },
    // 确认提现框打开
    openModalConfirmWithdraw () {
      this.modalConfirmWithdrawShow = true
    },
    openModalEarnMoreMoney () {
      this.modalEarnMoreMoneyShow = true
    },
    openModalPleaseContinue () {
      this.modalPleaseContinueShow = true
    },
    openRegisterAccount () {
      this.modalRegisterAccountShow = true
    },
    openModalOverSuccessful () {
      this.modalOverSuccessfulShow = true
      this.clearTimer()
    },
    openMoadlTopWinner () {
      this.moadlTopWinnerShow = true
    },
    openModalBoxGetReceived () {
      this.modalGetReceivedShow = true
    },
    closeNoSpinChancesYet () {
      this.modalBoxNoSpinChancesYetShow = false
    },
    earnChanceNoSpinChancesYet () {
      this.modalBoxNoSpinChancesYetShow = false
      this.openModalTask()
    },
    closeModalBoxGetChance (chanceNum) {
      this.modalBoxGetChanceShow = false
    },
    closeModalBoxShare (noTwo) {
      this.modalBoxShareShow = false
      if (this.isOpenModalTopWinner) {
        this.isOpenModalTopWinner = false
        setTimeout(() => {
          this.openMoadlTopWinner()
        }, 1000)
      }
    },
    closeModalTask (noShare) {
      this.modalTaskShow = false
      if (!noShare) {
        this.openModalBoxShare()
      } else if (noShare && this.balance !== 500 && this.UsedDrawCount === 4) {
        setTimeout(() => {
          this.openModalGuide()
        }, 500)
      }
    },
    getSuccess (UpdateNumber) {
      this.chanceNum = UpdateNumber
      this.openModalBoxGetChance()
      this.getViralityEnter(true)
      this.selectGet()
    },
    selectGet () {
      let data = {
        UserId: JSON.parse(localStorage.getItem('userInfo')) ? JSON.parse(localStorage.getItem('userInfo')).UserId : null

      }
      if (data.UserId) {
        request('post', 'innovation/virality/get/await/collect', data, false).then(res => {
          if (res.Code === 1) {
            this.canNums = res.BetAwait + res.DepositAwait
          }
        })
      }
    },
    closeModalGuide () {
      this.modalGuideShow = false
    },
    goInviteModalGuide () {
      this.modalGuideShow = false
      this.openModalBoxShare()
    },
    // 关闭提现确认弹框
    closeModalConfirmWithdraw (type) {
      this.modalConfirmWithdrawShow = false
      if (type !== 'ok') {
        setTimeout(() => {
          // this.openModalEarnMoreMoney()
        }, 500)
      } else {
        this.withdraw()
      }
    },
    closeModalEarnMoreMoney () {
      this.modalEarnMoreMoneyShow = false
      this.closePage()
    },
    closeModalPleaseContinue () {
      this.modalPleaseContinueShow = false
    },
    closeRegisterAccount () {
      this.modalRegisterAccountShow = false
    },
    closeModalOverSuccessful () {
      this.modalOverSuccessfulShow = false
      this.resetTimer()
    },
    closeMoadlTopWinner () {
      this.moadlTopWinnerShow = false
      this.openModalBoxShare()
    },
    closeModalBoxGetReceived () {
      if (this.UsedDrawCount === 4) {
        setTimeout(() => {
          this.openModalTask()
        }, 1000)
      }
      if (this.UsedDrawCount === 3) {
        setTimeout(() => {
          if (localStorage.getItem('shareVIRData') && !localStorage.getItem('userInfo')) {
            this.openRegisterAccount()
          } else {
            // this.aginOpenModalBoxShare = true
            this.isOpenModalTopWinner = true
            this.openModalBoxShare()
            // this.openModalBoxShare()
          }
        })
      }
      this.modalGetReceivedShow = false
    },
    closePage () {
      clearInterval(this.interval)
      if (this.backPath === 'back') {
        this.$router.back()
      } else {
        this.$router.push('/Home')
      }
    },
    getRandomData (list) {
      const randomIndex = Math.floor(Math.random() * list.length)
      return list[randomIndex]
    },
    updateCounter () {
      this.interval = setInterval(() => {
        setTimeout(() => {
          this.counter = 0
          setTimeout(() => {
            this.randomData = this.getRandomData(userDataList)
          }, 1000)
        }, 2000)
        this.counter = 2
      }, 4000)
      // this.interval = setInterval(() => {
      //   if (this.counter < 2) {
      //     this.counter += 1
      //   } else {
      //     //
      //     clearInterval(this.interval)
      //     this.counter = 0
      //     setTimeout(() => {
      //       this.updateCounter()
      //     }, 3000)
      //   }
      // }, 1000)
    },
    destroyedFunc () {
      this.counter = 0
      clearTimeout(this.timers)
      clearInterval(this.interval)
      this.clearTimer()
      this.removeEventListenerFromDocument()
      clearInterval(this.intervalId)
    },
    startTimer () {
      this.timer = setTimeout(() => {
        // this.openModalOverSuccessful()
      }, 5000)
    },
    clearTimer () {
      if (this.timer) {
        clearTimeout(this.timer)
        this.timer = null
      }
    },
    addEventListenerToDocument () {
      document.addEventListener('mousemove', this.resetTimer)
      document.addEventListener('keypress', this.resetTimer)
      document.addEventListener('touchstart', this.resetTimer)
    },
    removeEventListenerFromDocument () {
      document.removeEventListener('mousemove', this.resetTimer)
      document.removeEventListener('keypress', this.resetTimer)
      document.removeEventListener('touchstart', this.resetTimer)
    },
    resetTimer () {
      this.clearTimer()
      this.startTimer()
    }
  },
  beforeDestroy () {
    this.destroyedFunc()
  },
  destroyed () {
    clearInterval(this.interval)
  },
  created () {
  },
  mounted () {
    if (localStorage.getItem('isVIRShareLogin')) {
      this.openModalBoxShare()
      localStorage.removeItem('isVIRShareLogin')
    }
    this.getRule()
  }
}
</script>
<style lang='less' scoped>
.transparentMarsk{
  height: 100vh;
  width: 100vw;
  background-color: transparent;
  position: fixed;
  z-index: 9999;
}
.maskBox{
  height: 100vh;
  width: 100%;
  position: fixed;
  background-color: rgba(0,0,0,0.8);
  z-index: 999;
  display: flex;
  justify-content: center;
  align-items: center;
}
.noMaskBox{
  height: 100vh;
  width: 100%;
  position: fixed;
  background-color: rgba(0,0,0,0);
  z-index: 999;
  display: flex;
  justify-content: center;
  align-items: center;
}
.rewardBox{
  .chanceIcon{
    height: 20vw;
    width: 20vw;
  }
  .chanceNum{
    position: absolute;
    left: 15vw;
    top: 16vw;
    font-size: 3vw;
    color: #fff;
    font-weight: 700;
  }
}
.mainBox{
  background: #000;
 height: 100%;
  width: 100%;
  position: absolute;
  background-size: 100%;
  z-index: 9999;
  overflow-x: hidden;
  padding-bottom: 20vw;
  position: relative;
  .noStartMarsk{
    height: 292vw;
    width: 100%;
    background-color: rgba(0,0,0,.5);
    position: absolute;
    z-index: 999;
    .freezeBox1{
      display: flex;
      flex-direction: column;
      align-items: center;
      position: absolute;
      left: 50%;
      right: 50%;
      top: 53vw;
      .lock{
        height: 17.77vw;
        width: 17.77vw;
      }
      .text{
        width: 41.94vw;
        font-size: 5.55vw;
        font-weight: 700;
        text-align: center;
        color: #fff;
        margin-top: 1vw;
      }
    }
    .freezeBox2{
      display: flex;
      flex-direction: column;
      align-items: center;
      position: absolute;
      left: 50%;
      right: 50%;
      top: 216vw;
      .lock{
        height: 13.61vw;
        width: 13.61vw;
      }
      .text{
        width: 41.94vw;
        font-size: 5.55vw;
        font-weight: 700;
        text-align: center;
        color: #fff;
      }
    }
  }
  .sideBoderHide{
    width: 60vw;
    height: 17.22vw;
    background-size: 100% 100%;
    position: absolute;
    top: 107vw;
    left: -62vw;
    z-index: 99;
    display: flex;
    align-items: center;
    gap: 2vw;
    transition: all 0.2s linear;
    .userImg{
      height: 10.27vw;
      width: 10.27vw;
      border-radius: 6vw;
      margin-left: 3vw;
    }
    .textBox{
      display: flex;
      flex-direction: column;
      gap: 0.2vw;
      .userName{
        font-size: 3.33vw;
        color: #fff;
        font-weight: 700;
      }
      .description{
        display: flex;
        font-size: 2.5vw;
        .value{
          color:#F6D9AA;
        }
      }
      .reachedAccount{
        font-size: 2.5vw;
        color: #fff;
      }
    }
  }
  .sideBoder{
    width: 60vw;
    height: 17.22vw;
    background-size: 100% 100%;
    position: absolute;
    top: 107vw;
    left: -2vw;
    z-index: 99;
    display: flex;
    align-items: center;
    gap: 2vw;
    transition: all 0.2s linear;
    .userImg{
      height: 10.27vw;
      width: 10.27vw;
      border-radius: 6vw;
      margin-left: 3vw;
    }
    .textBox{
      display: flex;
      flex-direction: column;
      gap: 0.2vw;
      .userName{
        font-size: 3.33vw;
        color: #fff;
        font-weight: 700;
      }
      .description{
        display: flex;
        font-size: 2.5vw;
        .value{
          color:#F6D9AA;
        }
      }
      .reachedAccount{
        font-size: 2.5vw;
        color: #fff;
      }
    }
  }
  .ruleBtnIcon{
    height: 6.388vw;
    width: 5.858vw;
    position: absolute;
    top: 3vw;
    left: 88vw;
    z-index: 999;
  }
  .closeIcon{
    height: 4.5vw;
    position: absolute;
    top: 4vw;
    left: 7vw;
    z-index: 1000;
  }
  .closeBox{
    height: 5.888vw;
    //border: 1px solid red;
    position: absolute;
    z-index: 1000;
    top: 4vw;
    left: 3vw;
    display: flex;
    align-items: center;
    .back{
      width: 4.352vw;
      height: 5.888vw;
    }
    .backText{
      color: #959595;
      font-size: 4.5vw;
      margin-left: 2vw;
      font-weight: 700;
      font-family: Inter;
    }
  }
  @keyframes expandInOut {
    0% {
      transform: scale(0);
      opacity: 0;
    }
    50% {
      opacity: 1;
    }
    100% {
      transform: scale(1);
      opacity: 1;
    }
  }
  .ruleBoxMarsk{
    height: 100vh;
    width: 100%;
    position: fixed;
    background-color: rgba(0,0,0,0.6);
    z-index: 1000;
    display: flex;
    justify-content: center;
    align-items: center;

    .ruleBox{
      animation-name: expandInOut;
      animation-duration: 0.2s;
      animation-timing-function: ease-out;
      animation-fill-mode: forwards;
      height: 111.38vw;
      width: 88.34vw;
      background-color: #181818;
      border-radius: 3vw;
      display: flex;
      flex-direction: column;
      align-items: center;
      .closeRuleBtn{
        height: 4.055vw;
        width: 4.055vw;
        position: absolute;
        left: 81vw;
        top: -7vw;
      }
      .title{
        margin-top: 6vw;
        background-image: linear-gradient(to right, #F5EFBA, #F8EDC6);
        color: transparent;
        background-clip: text;
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
        font-weight: bold;
        font-size: 5.277vw;
      }
      .ruleContentBox{
        margin-top: 5vw;
        height: 88.11vw;
        width: 77.58vw;
        border-radius: 3vw;
        background-color: #FDFDF5;
        padding: 1.5vw;
        color: #000000;
        font-size: 3.88vw;
        font-weight: 700;
        overflow-y: auto;
        overflow-x: hidden;
      }
    }
  }
  .headBox{
    height: 36vw;
    width: 100%;
    //border: 1px solid red;
    position: relative;
    //top: 15vw;
    //background: red;
    z-index: 12;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 2vw;
    padding-top: 10vw;

    .title{
      background: -webkit-linear-gradient(left, #FFFFFF 0%, #CCCCCC 39%, #C2C2C2 56%, #FFFFFF 100%);
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
      display: inline-block;
      font-style: italic;
      font-size: 7.777vw;
      font-weight: 900;
      letter-spacing: 0.4vw;
      position: relative;
      text-transform: capitalize;
      background: linear-gradient(90.44deg, #E2EDD3 0.38%, #DABFBF 105.03%);
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
      background-clip: text;
      text-fill-color: transparent;
      top: 2.6vw;
    }
    .maxWin{
      color: #656565;
      font-size: 4.166vw;
      position: relative;
      top: 1vw;
    }
    .chanceBox{
      padding: 1.5vw 10vw;
      border-radius: 1.388vw;
      font-size: 3.611vw;
      font-weight: 700;
      position: relative;
      top: 2vw;
      z-index: 10;
      background: linear-gradient(144.66deg, rgba(255,255,255,0.1118) -3.26%, rgba(153,153,153,0.1118) 119.34%);
      .chance{
        background: -webkit-linear-gradient(left, #FFF3C5 0%, #EEFF90 100%);
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
        display: inline-block;
      }
      @keyframes shake {
        0%, 10%, 20%, 30%, 40%, 50%, 60%, 70%, 80%, 90%, 100% { transform: rotate(0deg); }
        5%, 15%, 25%, 35%, 45%, 55%, 65%, 75%, 85%, 95% { transform: rotate(-5deg); }
      }
      .ruleIconBoxMove{
        animation: shake 2s ease-in-out infinite;
        //border: 1px solid red;
        position: absolute;
        top: -3vw;
        left: 50vw;
      }
      .ruleIconBox{
        //border: 1px solid red;
        position: absolute;
        top: -3vw;
        left: 53vw;
      }
      .ruleIconNums{
        position: absolute;
        height: 3vw;
        width: 3vw;
        border-radius: 10vw;
        background-color: red;
        color: #fff;
        text-align: center;
        line-height: 3.2vw;
        top: 2vw;
        left: 0vw;
        font-size: 2vw;
        z-index: 100;
      }
      .ruleIcon{
        height: 9.166vw;
        width: 9.166vw;
        z-index: 10;
      }

    }

  }
  .btnBox{
    //width: 45.847vw;
    width: 100%;
    height: 13.611vw;
    //border: 1px solid red;
    position: absolute;
    z-index: 10;
    top: 132vw;
    display: flex;
    //align-items: center;
    align-items: flex-end;
    justify-content: center;
    gap: 1.802vw;
    .btnItem{
      height: 100%;
      width: 44.833vw;
      background-size: 100% 100%;
      color: #000;
      font-weight: 800;
      font-size: 4.027vw;
      font-family: 'Inter';
      font-style: normal;
      text-transform: capitalize;
      .label{
        position: relative;
        top: 4.6vw;
        left: 7vw;
        line-height: 5vw;
      }
    }
    .btnItem1{
      height: 100%;
      width: 44.833vw;
      background-size: 100% 100%;
      color: #000;
      font-weight: 800;
      font-size: 4.027vw;
      font-family: 'Inter';
      font-style: normal;
      text-transform: capitalize;
      .label{
        line-height: 5vw;
        position: relative;
        top: 4.5vw;
        left: 7.5vw;
      }
    }
  }
  .myWinBox{
    height: 46.388vw;
    width: 90.569vw;
    background-size: 100% 100%;
    position: absolute;
    z-index: 999;
    top: 148vw;
    left: 4.5vw;
    display: flex;
    flex-direction: column;
    //justify-content: space-around;
    align-items: center;
    .row1{
      position: relative;
      top: 4vw;
      color: #FFE688;
      font-size: 5vw;
      font-weight: 700;
      font-family: 'Inter';
      font-style: normal;
      font-weight: 700;
      text-transform: capitalize;
      background: linear-gradient(90deg, #DDEEAD 0%, #A4A195 100%);
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
      background-clip: text;
      text-fill-color: transparent;
    }
    .row2{
      position: relative;
      top: 10.2vw;
      color: #fff;
      font-size: 6.388vw;
      font-weight: 700;
    }
    @keyframes resizeButton {
      0%, 100% {
        transform: scale(0.9);
      }
      50% {
        transform: scale(1.05);
      }
    }
    .ReceiveReward{
      background-color: #FFD453;
      color: #000;
      font-weight: 700;
      font-size: 4.44vw;
      width: 77.5vw;
      height: 10.27vw;
      border-radius: 1.38vw;
      display: flex;
      align-items: center;
      justify-content: center;
      position: absolute;
      top: 34vw;
      animation: resizeButton 0.5s infinite linear;
    }
    .row3{
      display: flex;
      align-items: center;
      justify-content: space-between;
      position: relative;
      top: 18vw;
      width: 81.8vw;
      .leftBox{
        width: 60.66vw;
        font-size: 3.61vw;
        text-align: left;
        line-height: 4.166vw;
        color: #fff;
        letter-spacing: 0.2vw;
        font-family: 'Inter';
        font-style: normal;
        font-weight: 600;
        text-transform: capitalize;
        color: #E2E2E2;
        div{
          width: 100%;
        }
      }
      .rightBox{
        font-size: 6.111vw;
        font-family: 'Inter';
        font-style: normal;
        font-weight: 600;
        line-height: 27px;
        /* identical to box height */
        text-transform: capitalize;
        color: #E6D492;
      }
    }
  }
  .ListWinners{
    height: 42.5vw;
    width: 90.569vw;
    position: absolute;
    z-index: 10;
    top: 201vw;
    left: 4.4vw;
    background-size: 100% 100%;
    border-radius: 3vw;
    display: flex;
    flex-direction: column;
    align-items: center;
    overflow: hidden;
    .listViewMask{
      height: 100%;
      width: 100%;
      position: absolute;
      background-color: transparent;
      z-index: 10;
    }
    .listOfWinners{
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      height: 12vw;
      //border: 1px solid red;
      font-size: 4.722vw;
      color: #FFE687;
      font-weight: 700;
      letter-spacing: 0.1vw;
      font-family: 'Inter';
      font-style: normal;
      font-weight: 700;
      background: linear-gradient(90deg, #DDEEAD 0%, #A4A195 100%), #FFE687;
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
      background-clip: text;
      text-fill-color: transparent;
    }
    .listView::-webkit-scrollbar{
      opacity: 0;
      width: 0;
    }
    .listView{
      flex: 1;
      width: 100%;
      //background-color: green;
      overflow-x: hidden;
      overflow-y: auto;
      transition: scroll-top 0.5s ease-in-out;
      .viewItem:nth-child(odd) {
        height: 10.3vw;
        background: linear-gradient(
          90deg,
          rgba(0, 255, 119, 0.5) 0%,    /* 添加透明度 0.5 */
          rgba(18, 117, 74, 0.5) 100%   /* 添加透明度 0.5 */
        );
      }
      .viewItem:nth-child(even) {
        height: 10.3vw;
        background: transparent;
      }
        .viewItem{
        display: flex;
        align-items: center;
        justify-content: space-around;
        height: 10vw;
        width: 100%;
        //border: 1px solid red;
        font-size: 2.777vw;
        color: #fff;
          //border-bottom: 1px solid #fff;
        .userInfoBox{
          display: flex;
          align-items: center;
          gap: 2vw;
          flex: 1;
          //border: 1px solid red;
          .userImg{
            height: 6.55vw;
            width: 6.55vw;
            margin-left: 5vw;
            border-radius: 5vw;
          }
          .userName{
            font-weight: 700;
            width: 10vw;
          }
        }
        .TimeBox{
          flex: 1;
        }
        .withDraw{
          flex: 1;
          font-weight: 700;
          span{
            color: #FFE688;
          }
        }
      }
    }
  }
  .inviteBox{
    height: 47.5vw;
    width: 96.569vw;
    background-size: 100% 100%;
    background-repeat: no-repeat;
    //border: 1px solid red;
    position: absolute;
    z-index: 10;
    top: 242vw;
    left: 4.4vw;
    .labelBox{
      position: relative;
      top: 10vw;
      left: 4vw;
      .label1{
        color: #F8FFF6;
        font-size: 8.055vw;
        font-weight: 700;
        padding-bottom: 2vw;
        .value{
          color: rgb(250,240,66);
        }
      }
      .label1IN{
        color: #F8FFF6;
        font-size: 6.255vw;
        font-weight: 700;
        .value{
          color: rgb(250,240,66);
        }
      }
      .label2{
        color: #F8FFF6;
        font-weight: 700;
        font-size: 5.277vw;
      }
      .label2IN{
        color: #F8FFF6;
        font-weight: 700;
        font-size: 4.977vw;
      }
    }
    .inviteTip{
      color: #878787;
      font-size: 3.888vw;
      position: relative;
      top: 16vw;
      left: 4vw;
    }
    .inviteTipIN{
      width: 81.569vw;
      color: #878787;
      font-size: 2.888vw;
      position: relative;
      top: 19.5vw;
      left: 5vw;
      //border: 1px solid red;
    }
  }
}

//转盘
.lottery {
  width: 100%;
  position: relative;
  top: -25vw;
  z-index: 10;
  overflow: hidden;
}
.wheelBorder{
  width: 75vw;
  height: 137vw;
  margin: auto;
  border-radius: 50%;
  background-size: 100%;
  background-position-y: 32.5vw;
  background-position-x: 0.4vw;
  background-repeat: no-repeat;
  .bonusFocusImg {
    width: 40.691vw;
    height: 27.663vw;
    position: absolute;
    top: 35vw;
    left: 29.5vw;
    z-index: 11;
  }
}
.lottery-wheel {
  position: absolute;
  top: 1.2vw;
  left: -0.3vw;
 height: 100%;
  width: 100%;
  margin: auto;
  //background: url(https://rzlhhr.oss-cn-beijing.aliyuncs.com/20220622/b6427910-e086-4df1-9537-8700108e2690.png) 0 0 no-repeat;
  //background: green;
  border-radius: 200px;
  background-size:100%;
  //border: 20px solid #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  .prize-list {
    position: relative;
    width: 80vw;
    height: 80vw;
    left: 5vw;
    top: 7vw;
    .prize-item {
      display: flex;
      align-items: center;
      flex-direction: column;
      font-size: 3.611vw;
      font-weight: 700;
      width: 11.166vw;
      img {
        width: 15vw;
        height: 15vw;
      }
    }

    // 奖品样式
    .prize-item:nth-child(1) {
      position: absolute;
      top: 17%;
      left: 40%;
      transform: rotate(0);
      color: #fff;
      z-index: 11;
    }

    .prize-item:nth-child(2) {
      position: absolute;
      top: 29.5%;
      left: 53%;
      transform: rotate(62deg);
      color: #FDF2B7;
      z-index: 10;
    }

    .prize-item:nth-child(3) {
      position: absolute;
      top: 46%;
      left: 52%;
      transform: rotate(119deg);
      color: #fff;
      z-index: 10;
    }

    .prize-item:nth-child(4) {
      position: absolute;
      top: 57%;
      left: 37%;
      transform: rotate(180deg);
      color: #FDF2B7;
      z-index: 10;
    }

    .prize-item:nth-child(5) {
      position: absolute;
      top: 48%;
      left: 20%;
      transform: rotate(239deg);
      color: #642626;
      z-index: 10;
    }

    .prize-item:nth-child(6) {
      position: absolute;
      top: 24%;
      left: 23%;
      transform: rotate(300deg);
      color: #FDF2B7;
      z-index: 10;
    }
  }
}

.lotterydraw {
  position: absolute;
  left: 50%;
  top: 48%;
  margin-top: -10vw;
  margin-left: -10vw;
  z-index: 10;

  img {
    width: 15.77vw;
    position: relative;
    left: 2vw;
    top: 1.5vw;
  }
}

.lotteryname {
  position: absolute;
  top: 120vw;
  width: 100%;
  text-align: center;
}
/* 禁用 carousel 控制按钮 */
/deep/.el-carousel__arrow,
.el-carousel__button {
  display: none !important;
}
</style>



// WEBPACK FOOTER //
// src/pages/cashWheel/index.vue